//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['countries', 'actualCountry'],
  data() {
    return {
      country: this.actualCountry,
    };
  },
  methods: {
    countryChange() {
      this.$emit('country-changed', this.country);
    },
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/checkout/ShippingFields.vue